/* globals EB */
function LocalStorage() {
	this.expandLimit = 1;

	//this.expiry = 24 * 60 * 60 * 1000;

	//TODO : set namespace
	this.getNamespace = function() {
		var id = 'local';

		if (EB._adConfig && EB._adConfig.adId) {
			id = EB._adConfig.adId;
		}

		return 'com.massmotionmedia.' + id;
	};

	this.namespace = this.getNamespace();

	//TODO : getData once ??? , mini modif
	this.getData = function(dataName) {

		var now = new Date();
		var timestamp;
		var timestampDate;
		var count;
		try {
			timestamp = localStorage.getItem(this.namespace + '.' + dataName + 'TS');
			timestamp = timestamp ? Number(timestamp) : 0;
			timestampDate = new Date(timestamp);

			//si nous somme bien sur la même journée
			if (now.getDate() === timestampDate.getDate() && now.getMonth() === timestampDate.getMonth()) {
				count = localStorage.getItem(this.namespace + '.' + dataName);
			}

			return count ? Number(count) : 0;
		} catch (e) {
			console.log(e);
			return 0;
		}
	};

	this.setData = function(dataName, value) {
		try {
			localStorage.setItem(this.namespace + '.' + dataName, value);
			localStorage.setItem(this.namespace + '.' + dataName + 'TS', +(new Date));
		} catch (e) {}
	};

	this.incrementAutoExpand = function() {
		var count = this.getData('autoExpand');
		this.setData('autoExpand', ++count);
	};

	this.incrementHit = function() {
		var count = this.getData('hit');
		this.setData('hit', ++count);
	};

	this.shouldExpand = function() {
		var expanded = this.getData('autoExpand');
		return expanded < this.expandLimit;
	};

}

module.exports = LocalStorage;
